const { footerNav, footerSocial, footerPayments } = require("./footer_nav");
const { headerNav, infoSubmenu } = require("./header_nav");
const { imagesKeys } = require("./images_keys");

export {
    footerNav,
    footerSocial,
    footerPayments,
    headerNav,
    infoSubmenu,
    imagesKeys,
};
